import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import translateString from '../../utils/Locales';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import "./style.css";
import { Switch } from '@material-ui/core';
let t = translateString;

function descendingComparator(a, b, orderBy) {
  if(typeof b[orderBy] == 'number'){
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  }
  else {
    if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
      return -1;
    }
    if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
      return 1;
    }
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = props.headCells;

  return (
    <TableHead style={{ zIndex: 900 }}>
      <TableRow style={{ marginBottom: 10, }}>
      <TableCell></TableCell>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding={false ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{fontWeight: 'bold', width: headCell.id == '__' ? '20px' : 'auto'}}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: 1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

//create your forceUpdate hook
function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update the state to force render
}


export default function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState(props.headCells[0].id);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [searchText, setSearchText] = React.useState('');
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  var rows = props.rows;

  if (searchText != ''){
    rows = [];
    props.rows.forEach(r => {
      var found = false;
      var lowerSearch = searchText.toLowerCase();

      props.searchCols.forEach(element => {
        if (r[element] && r[element].toLowerCase().indexOf(lowerSearch) != -1) 
          found = true;
      }); 

      if (found == true)
        rows.push(r);
    });
  }

  const forceUpdate = useForceUpdate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.eventName);
   //   setSelected(newSelecteds);
      return;
    }
 //   setSelected([]);
  };


  const handleChange = (e) => {
    setSearchText(e.target.value);
    forceUpdate();

  }

  const resetSearch = () => {
    if (searchRef.current != null){
      searchRef.current.value = '';
      setSearchText('');
    }
    forceUpdate();
  }

  const handleClick = (id, name) => {
    
    if (props.onEventClick)
      props.onEventClick(id);

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

 //   setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  var searchRef = React.createRef();

  return (
    <div className={classes.root}>
      
      <div style={{marginBottom: 10, display: "inline-flex"}}>
        {t('cerca')}:
        <input ref={searchRef} value={searchText} style={{marginLeft: 10}} type="text" onChange={(e) => {handleChange(e)}}></input>
        <img alt="" style={{marginLeft: 10, marginTop: 2, cursor: "pointer", width: 20, height: 20}} onClick={resetSearch} src={ require('../../images/delete-button.png') } />
      </div>

      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={props.headCells}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.eventName);
                  return (
                    <TableRow
                      hover                      
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      style={{backgroundColor: props.students != undefined && row.corsi_ritiro.includes(props.currentCourse+';') && '#E7A9A2'}}
                    >
                      <TableCell padding="checkbox">
                        { /* <CheckBox elementId={row.id} onElementCheck={props.onElementCheck}/> */ }
                      </TableCell> 

                      {
                        props.headCells.map(elem => {
                          return <TableCell key={Math.random()} onClick={() => handleClick(row.id)} align="left">{row[elem.id]}</TableCell>;
                        })
                      }
                      
                      { (props.onDelete || props.onCopy || props.setActive || props.onTestDone || props.download || props.calendar || props.invoices || props.pdf || props.email || props.phone || props.addPerson || props.removePerson) && (
                          <TableCell align="right" className="iconsColumn" style={{display: 'flex', marginTop: 5, alignItems:'center'}}>
                            {
                              props.onDelete && <img alt="" src={ require('../../images/trash.png') } title={t('elimina')} className="icon" style={{marginRight: 20, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onDelete(row.id)}/> 
                            }
                            
                            {
                              props.onCopy && <ContentCopyIcon titleAccess={t('copia')} className="icon" style={{marginRight: 5, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onCopy(row.link)} />
                            }

                            {
                              props.setActive && <Switch checked={row.abilitato === '1'} 
                                onChange={() => props.setActive(row.id) }
                              />
                            }
                            
                            {
                              props.onTestDone && (
                                (!row.durata && row.id !== row.id_test) ? <RadioButtonUncheckedOutlinedIcon color='disabled'/> : (!row.durata && row.id === row.id_test) ? <ErrorOutlineOutlinedIcon style={{color: 'orange'}} /> : <CheckCircleOutlinedIcon color='success'/>
                              )
                            }




                            {props.download && <a href={row.filecontent} download> <img alt="" src={ require('../../images/download.png') } title='Download' className="icon" style={{marginRight: 5, height: '20px', width: '20px', cursor: 'pointer'}} /></a> }
                            {(props.calendar != undefined && props.calendar == true) && <img alt="" src={ require('../../images/calendar.png') } title={t('calendario')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => {
                                props.onCalendarClick(row.id);
                            } }/> }
                            {props.invoices && <img alt="" src={ require('../../images/bill.png') } className="icon" title={t('fatturazione')} style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onInvoicesPressed(row.id)}/> }
                            {(props.pdf != undefined && props.pdf == true) && <img alt="" src={ require('../../images/pdf.png') } title={t('genera_pdf')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => {
                              props.onPdfClicked && props.onPdfClicked(row.id);
                            }}/>}
                            {(props.mail != undefined && props.mail == true) &&  <img alt="" src={ require('../../images/email.png') } title={t('invia_email')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onSendMail && props.onSendMail(row.id)}/>}
                            {(props.phone != undefined && props.phone == true) &&  <img alt="" src={ require('../../images/smartphone.png') } title={t('invia_notifica')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onSendNotification && props.onSendNotification(row.id)}/>}
                            {(props.students != undefined && props.students && props.addPerson && !row.corsi_ritiro.includes(props.currentCourse+';')) &&  <img alt="" src={ require('../../images/remove-user.png') } title={t('segna_ritirato')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onRemoveStudent && props.onRemoveStudent(row.id)} />}
                            {(props.students != undefined && props.students && props.removePerson && row.corsi_ritiro.includes(props.currentCourse+';')) &&  <img alt="" src={ require('../../images/add-user.png') } title={t('segna_frequentante')} className="icon" style={{marginRight: 10, height: '20px', width: '20px', cursor: 'pointer'}} onClick={() => props.onAddStudent && props.onAddStudent(row.id)} />}
                          </TableCell>
                      )}
                    </TableRow>
                  );
                })}

            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25]}
          component="div"
          count={rows.length}
          rowsPerPage={25}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>

    </div>
  );
}